import React, { Component } from 'react';
import cn from 'classnames';

import './tooltip.scss';

class Tooltip extends Component {
	render() {
		const { children, place, position, show } = this.props;
		return (
			<div
				style={position}
				className={cn('tooltip', {
					show,
					'place-top': place === 'top',
					'place-bottom': place === 'bottom',
					'place-left': place === 'left',
					'place-right': place === 'right'
				})}
			>
				{children}
			</div>
		);
	}
}

export default Tooltip;
